"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _ = require('lodash');
var moment = require('moment');
var _require = require('../../../common/constant/inspection-modal-action.constant'),
  CANCEL = _require.CANCEL,
  CONTINUE = _require.CONTINUE,
  CREATE = _require.CREATE;
var _require2 = require('../../../common/constant/report-status.constant'),
  DRAFT = _require2.DRAFT;
var _require3 = require('../../../common/constant/role.constant'),
  INSPECT_MANAGER = _require3.INSPECT_MANAGER;
module.exports = /*@ngInject*/function ($window, $location, $scope, $uibModal, configurations, configuration, ChecklistService, PreferenceService, PartyService, ProfileService, ReportService) {
  var ctrl = this;
  var query = $location.search();
  ctrl.currentUser = ProfileService.getProfile();
  ctrl.init = function () {
    ctrl.configurations = _.sortBy(configurations, 'name');
    ctrl.selectedConfiguration = configuration;
    if (configuration) {
      ctrl.selectedConfiguration = ctrl.configurations.find(function (config) {
        return config._id === configuration._id;
      });
    }
    if (!ctrl.selectedConfiguration) {
      ctrl.selectedConfiguration = ctrl.configurations.find(function (config) {
        return config._id === PreferenceService.get().configuration;
      });
    }
    if (!ctrl.selectedConfiguration) {
      // eslint-disable-next-line prefer-destructuring
      ctrl.selectedConfiguration = ctrl.configurations[0];
    }
    ctrl.onSelectConfiguration();
  };
  ctrl.onSelectConfiguration = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var party, partyIds, memberQuery, member;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          PreferenceService.save('configuration', ctrl.selectedConfiguration._id);
          ctrl.selectedParty = null;
          ctrl.party = null;
          _context.next = 5;
          return PartyService.get({
            id: ctrl.selectedConfiguration.party
          }).$promise;
        case 5:
          party = _context.sent;
          _context.next = 8;
          return PartyService.mergePartyLocations(ctrl.selectedConfiguration, party);
        case 8:
          party = _context.sent;
          if (ProfileService.isInspector(ctrl.selectedConfiguration)) {
            ctrl.managerInspection = false;
          } else if (ProfileService.isManager(ctrl.selectedConfiguration) && ctrl.selectedConfiguration.managerInspection) {
            ctrl.managerInspection = true;
            partyIds = ctrl.currentUser.roles.filter(function (role) {
              return role.role === INSPECT_MANAGER;
            }).map(function (role) {
              return role.target.id;
            });
            party.members = party.members.filter(function (member) {
              return partyIds.indexOf(member.id) > -1;
            });
          }
          party.members = _.sortBy(party.members, [function (member) {
            return member.name.toLowerCase();
          }], ['name', 'description']);
          ctrl.party = party;
          $scope.$apply();
          if (query && query.appName) {
            // eslint-disable-next-line prefer-object-spread
            memberQuery = Object.assign({}, query);
            delete memberQuery.appName;
            member = _.find(ctrl.party.members, function (m) {
              return _.some([m.reference], memberQuery);
            });
            ctrl.selectParty(member, ctrl.party.type);
          }
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  ctrl.selectParty = function (member, type) {
    ctrl.selectedParty = member;
    ctrl.selectedParty.type = type;
    PartyService.getPeople({
      partyId: ctrl.selectedConfiguration.party,
      partyMemberId: member.id
    }, function (partyToPeople) {
      ctrl.partyToPeople = partyToPeople;
    });
  };

  // eslint-disable-next-line no-shadow
  ctrl.createReport = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(configuration, party) {
      var checklist, report, _yield$ReportService$, existingReport, response;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            ctrl.progress = true;
            _context2.next = 3;
            return ChecklistService.get({
              id: configuration.checklist
            });
          case 3:
            checklist = _context2.sent;
            report = ReportService.initializeReport(configuration, checklist, party, ctrl.currentUser, ctrl.managerInspection);
            if ($window.aptrinsic && typeof $window.aptrinsic === 'function') {
              $window.aptrinsic('track', 'selected-party', {
                partyId: party.id,
                partyName: party.name,
                partyDescription: party.description,
                partyType: party.type,
                configurationId: configuration._id,
                configurationName: configuration.name,
                programId: configuration.program,
                timestamp: new Date().toISOString()
              });
            }
            _context2.next = 8;
            return ReportService.findLatestDraft(report);
          case 8:
            _yield$ReportService$ = _context2.sent;
            existingReport = _yield$ReportService$.existingReport;
            ctrl.progress = false;
            if (!existingReport) {
              _context2.next = 27;
              break;
            }
            _context2.prev = 12;
            _context2.next = 15;
            return $uibModal.open({
              template: "<div class=\"modal-header header-info\">\n              <h3 class=\"modal-title\" id=\"modal-title\">Inspection Already Exists</h3>\n              <a ng-href=\"\" class=\"btn-cancel\"  ng-click=\"$ctrl.onClose('".concat(CANCEL, "')\" title=\"Cancel\">\n                <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\n              </a>\n            </div>\n\n            <div class=\"modal-body\" id=\"modal-body\">\n              You have an existing inspection for ").concat(report.configuration.name, "\n              - ").concat(report.party.name, " created on ").concat(moment(new Date(report.createdDate)).format('ll'), ".\n              Would you like to continue or start a new inspection?\n            </div>\n\n            <div class=\"modal-footer\">\n              <button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.onClose('").concat(CREATE, "')\">New Inspection</button>\n              <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.onClose('").concat(CONTINUE, "')\">Continue</button>\n            </div>\n          "),
              // eslint-disable-next-line
              controller: function controller($uibModalInstance) {
                var $ctrl = this;
                $ctrl.onClose = function (value) {
                  $uibModalInstance.close(value);
                };
              },
              controllerAs: '$ctrl'
            }).result;
          case 15:
            response = _context2.sent;
            _context2.next = 21;
            break;
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](12);
            response = CANCEL;
          case 21:
            if (!(response === CANCEL)) {
              _context2.next = 24;
              break;
            }
            ctrl.progress = false;
            return _context2.abrupt("return");
          case 24:
            if (!(response === CONTINUE)) {
              _context2.next = 27;
              break;
            }
            $location.path("/report/".concat(existingReport._id));
            return _context2.abrupt("return");
          case 27:
            ctrl.progress = true;
            report.status = DRAFT;
            // eslint-disable-next-line no-shadow
            ReportService._upload({}, report, function (report) {
              PreferenceService.save('showCompliantFindings', true);
              $location.path("/report/".concat(report._id));
            });
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[12, 18]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};